import {
  Button,
  ButtonVariant,
  FormMessage,
  FormMessageVariant,
  Icon,
  IconIdentifier,
} from '@aus-platform/design-system';
import React from 'react';
import type { SecurityConfiguredProps } from '../types';

export const SecurityConfigured: React.FC<SecurityConfiguredProps> = ({
  onViewBackupCodes,
  onChangeAuthApp,
}) => {
  // Variables.
  const securitySections = [
    {
      icon: IconIdentifier.Key,
      title: 'Backup Codes',
      description:
        'View or regenerate one-time backup codes for emergency account access. Each code can only be used once.',
      buttonLabel: 'View Backup Codes',
      onClick: onViewBackupCodes,
    },
    {
      icon: IconIdentifier.Mobile,
      title: 'Change Authentication App',
      description:
        "Update the app you use for two-factor authentication. You'll need to scan a new QR code with your new authenticator app.",
      buttonLabel: 'Change Authentication App',
      onClick: onChangeAuthApp,
    },
  ];

  return (
    <div className="settings-content">
      <div className="settings-content__body security-tab__configured">
        <FormMessage
          variant={FormMessageVariant.Info}
          className="security-tab__callout"
          message={
            <>
              <h4 className="security-tab__callout__title">
                Two-Factor Authentication Configured
              </h4>
              <p className="security-tab__callout__description">
                Your account is protected with two-factor authentication.
              </p>
            </>
          }
        />

        {securitySections.map((section) => (
          <div
            key={section.title}
            className="security-tab__configured__section"
          >
            <div className="security-tab__configured__section__header">
              <div className="security-tab__configured__section__icon">
                <Icon identifier={section.icon} size={20} />
              </div>
              <div className="security-tab__configured__section__content">
                <h4 className="security-tab__configured__section__title">
                  {section.title}
                </h4>
                <p className="security-tab__configured__section__description">
                  {section.description}
                </p>
                <Button
                  variant={ButtonVariant.Outline}
                  onClick={section.onClick}
                >
                  {section.buttonLabel}
                </Button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
